import { render, staticRenderFns } from "./BonDetail.vue?vue&type=template&id=b8544b64&scoped=true&"
import script from "./BonDetail.vue?vue&type=script&lang=js&"
export * from "./BonDetail.vue?vue&type=script&lang=js&"
import style0 from "./BonDetail.vue?vue&type=style&index=0&id=b8544b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8544b64",
  null
  
)

export default component.exports